import { getPasswordSchema } from "apps/visits/packages/shared/utils/yup";
import { t } from "i18next";
import * as yup from "yup";

export const useValidationSchema = () => {
  return yup.object({
    email: yup.string().email(t("COMMONS.ERRORS.INCORRECT_EMAIL")).required(t("COMMONS.ERRORS.REQUIRED")),
    emailConfirmation: yup.string().oneOf([yup.ref("email")], t("ERRORS.COMMONS.EMAIL_MATCH")),
    password: getPasswordSchema(t),
  });
};
